<div class="row align-items-center">
  <div class="sidebar-header-spacer"></div>
  <div class="col d-flex">
    <button nbButton shape="round" ghost status="control" size="giant" class="p-2 m-1 mr-3" (click)="toggleSidebar()">
      <nb-icon icon="menu"></nb-icon>
    </button>
    <h5 class="mt-2 title">{{ title | uppercase }}</h5>
  </div>
  <div class="col d-flex flex-row-reverse h-100">
    <div class="d-flex flex-column justify-content-center" [formGroup]="actionsForm">
      <nb-select id="menu" size="tiny" filled bfValidationStatus formControlName="menu" status="primary"
        placeholder="Opciones">
        <nb-option *ngFor="let item of list" [value]="item" style="font-size: 14px">
          <span class="option">
            {{ item }}
          </span>
        </nb-option>
      </nb-select>
    </div>
  </div>
</div>

<ng-template #dialog let-data let-ref="dialogRef">
  <ng-container *ngIf="successMessage">
    <div class="custom-dialog d-flex flex-column justify-content-center align-items-center pb-4"
      style="background-color: white">
      <div class="title-change-password text-center">
        <h3>Cambiar Clave</h3>
      </div>
      <div class="success-container d-flex flex-column align-items-center py-4 px-3">
        <nb-icon icon="checkmark-circle-2" status="success" style="font-size: 3rem; margin-bottom: 1rem;"></nb-icon>
        <p class="text-center mb-0" style="font-size: 1rem; color: #333;">Tu contraseña ha sido actualizada con éxito.</p>
      </div>
      <div class="d-flex flex-row justify-content-center mt-3 w-100">
        <button nbButton size="large" status="primary" class="fz-12 hg-10" (click)="navigate()">Aceptar</button>
      </div>
    </div>
  </ng-container>
  <div id="dialog" *ngIf="!successMessage" [formGroup]="changePasswordForm"
    class="custom-dialog d-flex flex-column justify-content-center align-items-center pb-4"
    style="background-color: white">
    <div class="title-change-password text-center">
      <h3>Cambiar Clave</h3>
    </div>
    <hr class="w-90" />
    <div class="form-group col-lg-8 col-md-8 col-sm-12">
      <label for="oldPassword" class="label">Clave actual</label>
      <div class="input-group">
        <input class="form-control" [type]="showOldPassword ? 'text' : 'password'" id="oldPassword"
          formControlName="oldPassword" nbInput fullWidth bfValidationStatus
          placeholder="Ingresá tu clave actual" />
        <div class="input-group-append">
          <nb-icon (click)="toggleShowOldPassword()" [icon]="showOldPassword ? 'eye-off' : 'eye'"></nb-icon>
        </div>
      </div>
      <div *ngIf="changePasswordForm.get('oldPassword').touched && changePasswordForm.get('oldPassword').invalid">
        <small class="text-danger" *ngIf="changePasswordForm.get('oldPassword').errors?.required">
          La clave actual es requerida.
        </small>
      </div>
    </div>
    <div class="form-group col-lg-8 col-md-8 col-sm-12">
      <label for="password" class="label">Nueva Clave</label>
      <div class="input-group">
        <input class="form-control" [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
          nbInput fullWidth bfValidationStatus
          placeholder="Mínimo 6 caracteres" />
        <div class="input-group-append">
          <nb-icon (click)="toggleShowPassword()" [icon]="showPassword ? 'eye-off' : 'eye'"></nb-icon>
        </div>
      </div>
      <div *ngIf="changePasswordForm.get('password').value" class="password-strength-container mt-1">
        <div class="password-strength-bar">
          <div *ngFor="let i of [1,2,3,4,5]" class="password-strength-segment"
            [style.background-color]="i <= passwordStrength.level ? passwordStrength.color : '#e0e0e0'"></div>
        </div>
        <small class="password-strength-label" [style.color]="passwordStrength.color">{{ passwordStrength.label }}</small>
      </div>
      <div *ngIf="changePasswordForm.get('password').touched && changePasswordForm.get('password').invalid">
        <small class="text-danger" *ngIf="changePasswordForm.get('password').errors?.required">
          La nueva clave es requerida.
        </small>
        <small class="text-danger" *ngIf="changePasswordForm.get('password').errors?.minlength">
          La clave debe tener al menos 6 caracteres.
        </small>
      </div>
      <div *ngIf="changePasswordForm.errors?.passwordSameAsOld && (changePasswordForm.get('password').touched || changePasswordForm.get('oldPassword').touched)">
        <small class="text-danger">La nueva clave no puede ser igual a la clave actual.</small>
      </div>
    </div>
    <div class="form-group col-lg-8 col-md-8 col-sm-12">
      <label for="repeatPassword" class="label">Repetir Nueva Clave</label>
      <div class="input-group">
        <input class="form-control" [type]="showRepeatPassword ? 'text' : 'password'" id="repeatPassword"
          formControlName="repeatPassword" nbInput fullWidth bfValidationStatus
          placeholder="Repetí la nueva clave" />
        <div class="input-group-append">
          <nb-icon (click)="toggleShowRepeatPassword()" [icon]="showRepeatPassword ? 'eye-off' : 'eye'"></nb-icon>
        </div>
      </div>
      <div *ngIf="changePasswordForm.errors?.passwordMismatch && changePasswordForm.get('repeatPassword').touched">
        <small class="text-danger">Las claves no coinciden.</small>
      </div>
    </div>
    <div *ngIf="changePasswordError" class="col-lg-8 col-md-8 col-sm-12 mb-2">
      <div class="error-banner">
        <nb-icon icon="alert-triangle" status="danger" style="font-size: 1rem; margin-right: 0.5rem;"></nb-icon>
        <small>{{ changePasswordError }}</small>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-around mt-3 w-100">
      <button nbButton size="large" class="mr-3 fz-12 hg-10" (click)="navigate()">Cerrar</button>
      <button nbButton size="large" class="mr-5 fz-12 hg-10" status="primary" [disabled]="changePasswordForm.invalid || isChangingPassword"
        (click)="changePassword()">
        {{ isChangingPassword ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>
  </div>
</ng-template>
